import { Alert, Box, CircularProgress, Container, Typography } from '@mui/material';
import React, { FC } from 'react';
// import titleImage from '../../../../assets/images/programm/ProgrammTitle.png';
// import HeroHeaderSection from '../../../../components/ui-component/hero-header/HeroHeader';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import { useFetchFoerderProgramm } from '../../../../hooks/FetchFoerderProgramm';
import FoerderProgrammGrid from './structure/FoerdProgrammGrid';

const FoerderProgrammeView: FC = () => {
	// const [programmView, setProgrammView] = useState<string>('grid');

	const { loading, data, error } = useFetchFoerderProgramm();

	// const updateProgramView = () => {
	// 	setProgrammView((prevValue) => (prevValue === 'list' ? 'grid' : 'list'));
	// };

	if (error) console.error('ERROR: Fetching Förderprogramme ', error);
	if (loading) return <LoadingBackdrop />;
	return (
		<>
			<Container>
				<Typography variant='h3' component={'h1'}>
					Förderprogramme Übersicht
				</Typography>
				<Typography variant='body1' sx={{ mt: '1rem', mb: '2rem' }}>
					Hier finden Sie unsere aktuelle(n) Ausschreibung(en).
				</Typography>
				<Box sx={{ mt: '2rem' }}>
					{loading && (
						<Box display='flex' justifyContent='center' mt={4}>
							<CircularProgress />
						</Box>
					)}
					{error && (
						<Alert severity='error' sx={{ mt: 4 }}>
							Fehler: {error}
						</Alert>
					)}
					{!loading && !error && data && <FoerderProgrammGrid data={data} />}
				</Box>
			</Container>
		</>
	);
};

export default FoerderProgrammeView;
